import { STEPS } from '../../utils/routes.util';

export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(STEPS.PRTV_INTERFACE_1, {
    url: '/prtv-interface-1',
    template: '<dmattnt-prtv-interface-1></dmattnt-prtv-interface-1>',
    data: {label: 'Étude approfondie'}
  }).state(STEPS.PRTV_INTERFACE_2, {
    url: '/prtv-interface-2',
    template: '<dmattnt-prtv-interface-2></dmattnt-prtv-interface-2>',
    data: {label: 'Demande d\'enquête'}
  }).state(STEPS.PRTV_INTERFACE_3, {
    url: '/prtv-interface-3',
    template: '<dmattnt-prtv-interface-3></dmattnt-prtv-interface-3>',
    data: {label: 'Contrôles à effectuer par vous-même'}
  }).state(STEPS.PRTV_INTERFACE_4, {
    url: '/prtv-interface-4',
    template: '<dmattnt-prtv-interface-4></dmattnt-prtv-interface-4>',
    data: {label: 'Informations complémentaires'}
  }).state(STEPS.PRTV_INTERFACE_5, {
    url: '/prtv-interface-5',
    template: '<dmattnt-prtv-interface-5></dmattnt-prtv-interface-5>',
    data: {label: 'Validation des informations'}
  }).state(STEPS.PRTV_INTERFACE_6, {
    url: '/prtv-interface-6',
    template: '<dmattnt-prtv-interface-6></dmattnt-prtv-interface-6>',
    data: {label: 'Informations validées'}
  }).state(STEPS.PRTV_DEPOT_FACTURE, {
    url: '/prtv-depot-facture',
    template: '<dmattnt-prtv-depot-facture></dmattnt-prtv-depot-facture>',
    data: {label: 'Dépôt facture'}
  }).state(STEPS.PRTV_DEPOT_FACTURE_2, {
    url: '/prtv-depot-facture-2',
    template: '<dmattnt-prtv-depot-facture-2></dmattnt-prtv-depot-facture-2>',
    data: {label: 'Confirmation des informations de l’antenniste'}
  }).state(STEPS.PRTV_DEPOT_FACTURE_3, {
    url: '/prtv-depot-facture-3',
    template: '<dmattnt-prtv-depot-facture-3></dmattnt-prtv-depot-facture-3>',
    data: {label: 'Informations transmises'}
  });
}



// WEBPACK FOOTER //
// ./src/modules/prtv/routes.js